import { createRouter, createWebHistory, RouterView } from "vue-router";
// const homeBaseRoute = [
//   { path: "", redirect: "Welcome" },
//   {
//     path: "Welcome",
//     name: "homeWelcome",
//     meta: { title: "首页", affix: true },
//     component: () => import("../views/home/Welcome.vue"),
//   },
// ];
const routes = [
  {
    path: "",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/Login.vue"),
  },
    {
    path: "/JKlogin",
    name: "JKlogin",
    component: () => import("../views/login/JKlogin.vue"),
  },
  {
    path: "/YSlogin",
    name: "YSlogin",
    component: () => import("../views/login/YSlogin.vue"),
  },
  {
    path: "/GXlogin",
    name: "GXlogin",
    component: () => import("../views/login/GXlogin.vue"),
  },
  {
    path: "/BookSearchs",
    name: "BookSearchs",
    meta: { title: "图书搜索", keepAlive: false },
    component: () => import("../views/library/bookSearchs/BookSearchs.vue"),
  },
    {
    path: "/BookRetrieval",
    name: "BookRetrieval",
    meta: { title: "图书搜索", keepAlive: false },
    component: () => import("../views/library/bookSearchs/BookRetrieval.vue"),
  },
  {
    path: "/Book",
    name: "Book",
    component: () => import("../views/library/bookSearchs/BookSearchstest.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/layout/home.vue"),
    children: [
      // { path: "", redirect: "Welcome" },
      {
        path: "Welcome",
        name: "Welcome",
        meta: { title: "首页", keepAlive: false },
        component: () => import("../views/home/Welcome.vue"),
      },
      {
        path: "ApplicationMall",
        name: "ApplicationMall",
        meta: { title: "应用商城", keepAlive: false },
        component: () => import("../views/home/applicationMall/ApplicationMall.vue"),
      },
    ],
  },
  {
    path: "/excption/:errtype",
    name: "excption",
    component: () => import("../views/layout/excption.vue"),
  },
  {
    path: "/TaiHeBigView",
    name: "TaiHeBigView",
    component: () => import("../views/TaiHeBigView/home.vue"),
  },

  {
    path: "/JiangXiScreen",
    name: "JiangXiScreen",
    component: () => import("../views/TaiHeBigView/newHome.vue"),
  },
  {
    path: "/configuration",
    name: "configuration",
    component: () => import("../views/configuration/infoFrom.vue"),
  },
  {
    path: "/infoFromtabs",
    name: "infoFromtabs",
    component: () => import("../views/configuration/infoFromtabs.vue"),
  },
  {
    path: "/JiangXiScreen",
    name: "JiangXiScreen",
    component: () => import("../views/TaiHeBigView/newHome.vue"),
  },
  {
    path: "/currentReaderBorrowing",
    name: "CurrentReaderBorrowing",
    component: () =>
      import("../views/library/circulationSearch/CurrentReaderBorrowing.vue"),
  },
  {
    path: "/readerBorrowHistory",
    name: "ReaderBorrowHistory",
    component: () =>
      import("../views/library/circulationSearch/ReaderBorrowHistory.vue"),
  },
  {
    path: "/circulateLogList",
    name: "CirculateLogList",
    component: () =>
      import("../views/library/logManagement/CirculateLogList.vue"),
  },
  {
    path: "/loginInfolog",
    name: "LoginInfo",
    component: () => import("../views/library/logManagement/LoginInfo.vue"),
  },
  {
    path: "/smsSendLog",
    name: "SmsSendLog",
    component: () => import("../views/library/logManagement/SmsSendLog.vue"),
  },
  {
    path: "/literatureBorrowRank",
    name: "literatureBorrowRank",
    component: () =>
      import("../views/library/reportStatistics/literatureBorrowRank.vue"),
  },
];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});




export function setRouterAddrs(routerList, array = []) {
  routerList.forEach((route) => {
    //获取组件的名称
    // 目录唯一标识
    route.path = route.cname;
    if (route.ename) {
      const arrPath = route.ename.split("/");
      const routePath = arrPath[arrPath.length - 1];
      //路由地址名首字母大写就是对应的组件名称,这是定义规范
      const vueElName = routePath.replace(
        routePath[0],
        routePath[0].toUpperCase()
      );
      route.path = "/home/" + routePath;
      let obj = {
        path: routePath,
        name: vueElName,
        meta: { title: route.cname, keepAlive: true },
      };
      const subElPath = route.ename.substr(
      route.ename.indexOf("/"),
        route.ename.length
      );
      obj.component = () => import(/* @vite-ignore */ `@/views${subElPath}`);
      array.push(obj);
    }
    //如果存在子路由则递归生成组件,一般只有一个父子两层。
    if (route.children != undefined && route.children.length > 0) {
      setRouterAddrs(route.children, array);
    }
  });
  return array;
}

/* 前提要求组件名和定义的path名字符相同，这里通过懒加载方式加载对应的路由组件 */
const loadView = (elPath, vueElName) => {
  //拼接懒加载组件的路径
  const subElPath = elPath.substr(0, elPath.lastIndexOf("/"));
  return () => import("../" + subElPath + "/" + vueElName);
};

export default router;
